import client from '@lib/api/client'
import { useMutation } from '@tanstack/react-query'
import type { LoginMutationRequest, LoginMutationResponse, Login400, Login401 } from '../../models/usersModels/Login'
import type { UseMutationOptions } from '@tanstack/react-query'

type LoginClient = typeof client<LoginMutationResponse, Login400 | Login401, LoginMutationRequest>
type Login = {
  data: LoginMutationResponse
  error: Login400 | Login401
  request: LoginMutationRequest
  pathParams: never
  queryParams: never
  headerParams: never
  response: LoginMutationResponse
  client: {
    parameters: Partial<Parameters<LoginClient>[0]>
    return: Awaited<ReturnType<LoginClient>>
  }
}
/**
 * @summary Login based on UserName or Email and Password
 * @link /api/Users/login/account
 */
export function useLogin(
  options: {
    mutation?: UseMutationOptions<Login['response'], Login['error'], Login['request']>
    client?: Login['client']['parameters']
  } = {}
) {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {}
  return useMutation({
    mutationFn: async (data) => {
      const res = await client<Login['data'], Login['error'], Login['request']>({
        method: 'post',
        url: `/api/Users/login/account`,
        data,
        ...clientOptions
      })
      return res.data
    },
    ...mutationOptions
  })
}
